/* Zumm Health — blog content (reformatted from zummhealth.com/blogs/news, FDA-compliant) */
window.BLOG_CATEGORIES = {
  'Gut Health': {
    color: '#3FD598',
    chip: 'rgba(45,155,111,.16)',
    bd: 'rgba(63,213,152,.4)'
  },
  'Immunity': {
    color: '#5E8BC4',
    chip: 'rgba(94,139,196,.16)',
    bd: 'rgba(94,139,196,.45)'
  },
  'Digestion': {
    color: '#FF8C42',
    chip: 'rgba(255,140,66,.16)',
    bd: 'rgba(255,140,66,.45)'
  },
  'Gut-Brain': {
    color: '#F4E04D',
    chip: 'rgba(244,224,77,.15)',
    bd: 'rgba(244,224,77,.45)'
  },
  'Trends': {
    color: '#E4453A',
    chip: 'rgba(228,69,58,.15)',
    bd: 'rgba(228,69,58,.45)'
  }
};
window.BLOG = [{
  slug: 'skip-the-gummy-probiotics',
  title: 'Why Gummy Probiotics Fall Short for Kids',
  category: 'Trends',
  readMins: 3,
  date: 'April 15, 2026',
  heroEmoji: '🍬',
  excerpt: 'Gummy probiotics look like candy and taste like candy. Here’s why capsules may be the smarter pick for your child’s gut.',
  keyStat: {
    value: '10×',
    label: 'more live bacteria in capsules vs. typical gummies'
  },
  sections: [{
    h: 'Gummies are everywhere',
    p: 'Walk down any vitamin aisle and you’ll see gummy probiotics in bright colors and fun shapes. Kids love them because they taste like candy. But easy to take doesn’t always mean good for your child.'
  }, {
    h: 'The sugar catch',
    p: 'Most gummy probiotics have 2 to 5 grams of added sugar per serving. Sugar can feed the less helpful bacteria in the gut. Adding sugar to a gut supplement works against the whole point of taking one.'
  }, {
    h: 'Live bacteria that don’t make it',
    p: 'Probiotics are measured in CFU — the live bacteria that do the work. Gummies usually have only 1 to 3 billion CFU, and they’re made with heat, which can kill bacteria. Fewer may survive than the label suggests.'
  }, {
    h: 'Getting past stomach acid',
    p: 'The stomach is very acidic, and helpful bacteria need to reach the intestines to do their job. Gummies offer no protection from that acid. Delayed-release capsules are designed to help bacteria survive the trip.'
  }, {
    h: 'Capsules kids can actually take',
    p: 'Modern twist-open capsules let you sprinkle the contents into applesauce, yogurt, or a smoothie — so there’s no pill to swallow. You get higher CFU counts, acid-resistant delivery, and no added sugar.'
  }],
  takeaways: ['Gummies win on taste but often lose on quality.', 'Check CFU count, delivery method, and added sugar on the label.', 'Twist-open capsules mix into food, so kids don’t swallow pills.', 'Capsules may better support digestive health than gummies.'],
  diagram: {
    type: 'comparison',
    title: 'Gummies vs. Capsules',
    highlight: '10× more live cultures in capsules',
    left: {
      label: 'Gummy',
      icon: '🍬',
      tone: 'bad',
      items: ['2–5 g added sugar', '1–3 billion CFU', 'Made with heat', 'No acid protection', 'Artificial colors']
    },
    right: {
      label: 'Capsule',
      icon: '💊',
      tone: 'good',
      items: ['0 g added sugar', '~10× more CFU', 'Acid-resistant delivery', 'Clean, short ingredients', 'Twist-open into food']
    }
  }
}, {
  slug: 'gut-health-and-your-childs-mood',
  title: 'Happy Tummy, Happy Kid: The Gut–Mood Link',
  category: 'Gut-Brain',
  readMins: 3,
  date: 'March 29, 2026',
  heroEmoji: '🧠',
  excerpt: 'Ever notice your child gets cranky with a tummy ache? The gut and brain are constantly talking — and it may shape their mood.',
  keyStat: {
    value: '~90%',
    label: 'of the body’s serotonin is made in the gut'
  },
  sections: [{
    h: 'The gut–brain hotline',
    p: 'The gut has its own nervous system with over 500 million neurons — more than the spinal cord. This “second brain” talks to the real brain all day long through the vagus nerve, hormones, and immune signals.'
  }, {
    h: 'Mood chemicals made in the belly',
    p: 'The trillions of bacteria in your child’s gut help make and manage many mood chemicals. About 90% of the body’s serotonin is made in the gut, along with calming GABA and motivating dopamine.'
  }, {
    h: 'What research suggests',
    p: 'A 2024 research review found that kids with a less balanced gut microbiome more often reported anxiety, low mood, and irritability. Studies also suggest probiotics that support gut balance may help support a steadier mood.'
  }, {
    h: 'A cool finding',
    p: 'Research suggests children with more diverse gut bacteria handled stressful tasks better and showed lower cortisol — the stress hormone. A healthy gut may help kids stay calmer under pressure.'
  }, {
    h: 'Supporting the gut',
    p: 'Probiotics, a fiber-rich diet, and less sugar may all help support a healthy gut microbiome. Supporting the gut is one simple way to care for your child’s overall wellbeing from the inside out.'
  }],
  takeaways: ['The gut and brain talk constantly through the vagus nerve.', 'Most of the body’s serotonin is made in the gut.', 'Research suggests gut balance may help support mood.', 'Fiber, probiotics, and less sugar all support gut health.'],
  diagram: {
    type: 'cycle',
    title: 'The Gut–Brain Loop',
    center: 'Two-way\nconversation',
    nodes: [{
      icon: '🧠',
      label: 'Brain'
    }, {
      icon: '↔️',
      label: 'Vagus nerve'
    }, {
      icon: '🦠',
      label: 'Gut'
    }],
    chips: ['Serotonin ~90% made in gut', 'GABA — calming', 'Dopamine — motivation']
  }
}, {
  slug: 'probiotics-for-kid-constipation',
  title: 'Constipation in Kids? 5 Reasons to Consider Probiotics',
  category: 'Digestion',
  readMins: 3,
  date: 'March 29, 2026',
  heroEmoji: '🚽',
  excerpt: 'Childhood constipation is common and stressful. Here’s how probiotics may help support regular, comfortable digestion.',
  keyStat: {
    value: 'up to 30%',
    label: 'of children deal with constipation at some point'
  },
  sections: [{
    h: 'A very common problem',
    p: 'If your child goes days without a bowel movement or hurts when they go, you’re not alone. Constipation affects up to 30% of children at some point and is a top reason parents visit the pediatrician.'
  }, {
    h: 'Why it happens',
    p: 'Constipation happens when stool moves too slowly and the colon absorbs too much water, leaving hard, painful stools. Common causes include low fiber, not enough water, stress, and an imbalanced gut microbiome.'
  }, {
    h: 'How probiotics may help',
    p: 'Probiotics make short-chain fatty acids that support the muscles behind bowel movements. In studies, kids taking probiotics often had more bowel movements per week than those on a placebo — and softer, easier-to-pass stools.'
  }, {
    h: 'Gentle for daily use',
    p: 'Unlike laxatives, probiotics don’t create dependence and are gentle enough for daily, long-term use in children. That makes them an easy habit to keep up.'
  }, {
    h: 'Pair them with good habits',
    p: 'Probiotics work best alongside more fiber, steady water through the day, a regular toilet routine after meals, and daily activity. Together these support comfortable, regular digestion.'
  }],
  takeaways: ['Constipation affects up to 30% of kids at some point.', 'Probiotics may help support gut motility and softer stools.', 'They’re gentle and don’t cause dependence like laxatives.', 'Best paired with fiber, water, and a toilet routine.'],
  diagram: {
    type: 'list',
    title: '5 Ways Probiotics May Support Regularity',
    stat: {
      value: 'up to 30%',
      label: 'of kids affected at some point'
    },
    items: [{
      icon: '⚡',
      text: 'Support gut transit speed (short-chain fatty acids)'
    }, {
      icon: '📅',
      text: 'More bowel movements per week in studies'
    }, {
      icon: '💧',
      text: 'Softer, easier-to-pass stools'
    }, {
      icon: '🌱',
      text: 'Support microbiome diversity'
    }, {
      icon: '♻️',
      text: 'Gentle enough for daily, long-term use'
    }]
  }
}, {
  slug: 'probiotics-after-antibiotics-kids',
  title: 'After Antibiotics, Your Kid’s Gut Needs a Reset',
  category: 'Immunity',
  readMins: 3,
  date: 'March 29, 2026',
  heroEmoji: '💊',
  excerpt: 'Antibiotics wipe out good bacteria along with the bad. Here’s how probiotics may help your child’s gut bounce back.',
  keyStat: {
    value: '64%',
    label: 'fewer cases of antibiotic-associated diarrhea in one review'
  },
  sections: [{
    h: 'Antibiotics do double duty',
    p: 'Antibiotics are lifesavers that knock out harmful infections. But they can’t tell good bacteria from bad, so they also clear out billions of the helpful bacteria in your child’s gut.'
  }, {
    h: 'What gets disrupted',
    p: 'Studies show a single course of antibiotics can lower gut bacterial diversity by up to 30%, and some strains take 1 to 2 years to fully recover. That’s often why kids get tummy trouble afterward.'
  }, {
    h: 'How probiotics may help',
    p: 'A 2024 research review found children who took probiotics with and after antibiotics had a 64% reduction in antibiotic-associated diarrhea, faster return of gut diversity, and fewer follow-up infections.'
  }, {
    h: 'A cool fact',
    p: 'The gut holds about 38 trillion bacteria — more than the number of cells in the whole human body. That’s a big community to help rebuild after antibiotics.'
  }, {
    h: 'When to start',
    p: 'You can begin probiotics at the same time as antibiotics — just take them a few hours apart so the antibiotic doesn’t cancel them out. Keep going for at least 2 to 4 weeks after the course ends.'
  }],
  takeaways: ['Antibiotics clear out good gut bacteria along with the bad.', 'Diversity can drop up to 30% and take 1–2 years to recover.', 'A review linked probiotics to 64% fewer diarrhea cases.', 'Start alongside antibiotics (a few hours apart), continue 2–4 weeks after.'],
  diagram: {
    type: 'flowchart',
    title: 'The Antibiotic Recovery Timeline',
    stat: {
      value: '64%',
      label: 'fewer diarrhea cases in one review'
    },
    steps: [{
      label: 'Antibiotics start',
      sub: 'diversity ↓ up to 30%'
    }, {
      label: 'Add probiotics',
      sub: 'a few hours apart'
    }, {
      label: 'Finish antibiotics',
      sub: 'keep probiotics going'
    }, {
      label: '2–4 weeks after',
      sub: 'gut rebuilding'
    }]
  }
}, {
  slug: 'probiotics-tummy-bug-recovery',
  title: 'Tummy Bug? Probiotics May Help Kids Bounce Back Faster',
  category: 'Digestion',
  readMins: 3,
  date: 'March 29, 2026',
  heroEmoji: '🤢',
  excerpt: 'When a stomach bug sweeps through your home, research suggests probiotics may help support a faster, smoother recovery.',
  keyStat: {
    value: '~24 hrs',
    label: 'shorter diarrhea in studies'
  },
  sections: [{
    h: 'When the stomach bug hits',
    p: 'A tummy bug can move through the whole house fast. It brings diarrhea, vomiting, and cramps that may last a few days. That means missed school, tired parents, and lots of laundry.'
  }, {
    h: 'What the research says',
    p: 'A large review of 63 clinical trials looked at kids with stomach bugs. Children who took probiotics had diarrhea that lasted about 24 hours less on average. Some studies also saw fewer episodes per day.'
  }, {
    h: 'How probiotics may help',
    p: 'Probiotics are friendly bacteria that support a healthy gut balance. They may help crowd out unwanted bacteria and support the gut lining and immune cells. This can help the gut get back to normal.'
  }, {
    h: 'The most-studied strain',
    p: 'Lactobacillus rhamnosus GG is the most studied probiotic for kids’ tummies. It has been tested in thousands of children across many countries with steady results.'
  }, {
    h: 'Simple steps to feel better',
    p: 'Start probiotics at the first sign of trouble. Keep your child hydrated with water or an oral rehydration drink. Offer bland foods like rice, toast, and banana when ready, and keep probiotics going for a few days after.'
  }],
  takeaways: ['In studies, probiotics were linked to about a day less of diarrhea.', 'They may help restore a healthy gut balance during illness.', 'L. rhamnosus GG is the most-studied strain for tummies.', 'Hydration and rest still matter most while recovering.'],
  diagram: {
    type: 'bars',
    title: 'Average Diarrhea Duration',
    note: 'Based on a review of 63 clinical trials.',
    bars: [{
      label: 'Without probiotics',
      pct: 100,
      txt: 'full length'
    }, {
      label: 'With probiotics',
      pct: 66,
      txt: '~24 hrs shorter'
    }]
  }
}, {
  slug: 'probiotics-itchy-skin-eczema',
  title: 'Itchy Skin? The Gut–Skin Link Parents Should Know',
  category: 'Gut-Brain',
  readMins: 3,
  date: 'March 29, 2026',
  heroEmoji: '🧴',
  excerpt: 'Constant scratching is exhausting. New research on the gut–skin connection suggests probiotics may help support calmer skin.',
  keyStat: {
    value: 'up to 20%',
    label: 'of kids deal with eczema'
  },
  sections: [{
    h: 'The itch that won’t quit',
    p: 'If your child scratches their arms, legs, or belly — especially at night — you know how draining eczema can be. It affects up to 20% of children. New research points to a surprising source: the gut.'
  }, {
    h: 'Meet the gut–skin axis',
    p: 'Scientists call the link between the gut and the skin the gut–skin axis. The bacteria in your child’s gut help manage inflammation across the whole body, including the skin. When that balance is off, skin can be affected too.'
  }, {
    h: 'What the research shows',
    p: 'A 2024 review found children who took probiotics had lower eczema severity scores than those on a placebo. Another study found probiotics given to moms and newborns were linked to up to a 22% lower chance of eczema developing.'
  }, {
    h: 'Diversity matters',
    p: 'Kids with eczema often have less diverse gut bacteria than kids without it. Probiotics may help support that diversity. Well-studied strains include Lactobacillus rhamnosus GG and Bifidobacterium longum.'
  }, {
    h: 'Everyday skin support',
    p: 'Use gentle, fragrance-free soaps and moisturize daily. Offer fruits, veggies, and omega-3 foods. Adding a quality probiotic to the daily routine may help support gut balance from the inside.'
  }],
  takeaways: ['The gut and skin are closely linked through the gut–skin axis.', 'Research links probiotics with lower eczema severity in kids.', 'Kids with eczema often have less diverse gut bacteria.', 'Gentle skin care plus gut support may work best together.'],
  diagram: {
    type: 'flowchart',
    title: 'The Gut–Skin Connection',
    stat: {
      value: '22%',
      label: 'lower eczema risk in one study'
    },
    steps: [{
      label: 'Balanced gut bacteria',
      sub: 'diverse microbiome'
    }, {
      label: 'Balanced inflammation',
      sub: 'calmer signals'
    }, {
      label: 'Healthier-feeling skin',
      sub: 'less irritation'
    }]
  }
}, {
  slug: 'daily-probiotic-fewer-sick-days',
  title: 'Fewer Sick Days? Why Immunity Starts in the Gut',
  category: 'Immunity',
  readMins: 3,
  date: 'March 29, 2026',
  heroEmoji: '🛡️',
  excerpt: 'Most immune cells live in the gut. A daily probiotic may help support your child’s immune function and everyday defenses.',
  keyStat: {
    value: '70–80%',
    label: 'of immune cells live in the gut'
  },
  sections: [{
    h: 'Immunity starts in the belly',
    p: 'Here’s a surprise: about 70–80% of immune cells live in the digestive tract. When the gut is full of friendly bacteria, those immune cells are better trained and better prepared to do their job.'
  }, {
    h: 'How probiotics support immunity',
    p: 'Probiotics are live, helpful bacteria that work with your child’s own cells. They may help strengthen the gut barrier, support immune cells, ease unnecessary inflammation, and produce natural protective compounds.'
  }, {
    h: 'What the research shows',
    p: 'A 2024 review found children who took probiotics had fewer upper-respiratory infections, like colds, and missed fewer school days. Strains like Lactobacillus rhamnosus GG and Bifidobacterium lactis stood out.'
  }, {
    h: 'How long it takes',
    p: 'Most research shows immune benefits build over about 4–8 weeks of steady use. Think of it like exercise for the immune system: the more regular it is, the stronger it gets over time.'
  }, {
    h: 'What to look for',
    p: 'Choose a multi-strain product with at least 5 billion CFU for kids. Helpful strains include Lactobacillus rhamnosus GG, Bifidobacterium lactis Bb-12, and Lactobacillus acidophilus.'
  }],
  takeaways: ['Most of the immune system lives in the gut.', 'Research links daily probiotics with fewer colds and school absences.', 'Benefits tend to build over 4–8 weeks of steady use.', 'Look for a multi-strain kids’ formula with at least 5 billion CFU.'],
  diagram: {
    type: 'stat-row',
    title: 'Immunity by the Numbers',
    tiles: [{
      icon: '🛡️',
      value: '70–80%',
      label: 'immune cells that live in the gut'
    }, {
      icon: '📅',
      value: '4–8 wks',
      label: 'typical time to build benefits'
    }, {
      icon: '💧',
      value: '5B+ CFU',
      label: 'recommended for kids'
    }]
  }
}, {
  slug: 'probiotics-fewer-colds-school',
  title: 'Fewer Colds, Fewer Missed School Days',
  category: 'Immunity',
  readMins: 3,
  date: 'March 29, 2026',
  heroEmoji: '🤧',
  excerpt: 'The average kid catches 6–10 colds a year. Research suggests a daily probiotic may help support their defenses.',
  keyStat: {
    value: '6–10',
    label: 'colds per year for the average kid'
  },
  sections: [{
    h: 'So many colds',
    p: 'The average child catches 6 to 10 colds a year. That adds up to lots of sick days, missed school, and late nights for parents. A simple daily habit may help support their defenses.'
  }, {
    h: 'The science behind it',
    p: 'In the gut, friendly bacteria may help activate natural defender cells, support protective antibodies in the airway lining, keep inflammation balanced, and crowd out unwanted germs — all supporting healthy immune function.'
  }, {
    h: 'What clinical trials found',
    p: 'A 2024 meta-analysis found kids taking probiotics had about 1.2 fewer respiratory infections per year, and colds that eased roughly 1.9 days faster. Researchers also saw fewer school absences and less antibiotic use.'
  }, {
    h: 'A notable finding',
    p: 'In one study, daycare kids taking daily probiotics had 46% fewer days on antibiotics than kids who didn’t. That’s good news for children and for slowing antibiotic resistance.'
  }, {
    h: 'Getting ready for cold season',
    p: 'Start probiotics before cold season, since it can take 4 to 6 weeks to build full benefit. Keep your child hydrated, prioritize sleep, and offer foods rich in zinc and vitamin C alongside their probiotic.'
  }],
  takeaways: ['Kids average 6–10 colds a year.', 'Studies link probiotics with fewer, shorter respiratory infections.', 'One study saw 46% fewer antibiotic days in daycare kids.', 'Start 4–6 weeks before cold season for full benefit.'],
  diagram: {
    type: 'list',
    title: 'What Studies Linked to Daily Probiotics',
    stat: {
      value: '2024',
      label: 'meta-analysis of studies in children'
    },
    items: [{
      icon: '📉',
      text: '1.2 fewer respiratory infections per year'
    }, {
      icon: '⏱️',
      text: 'Colds about 1.9 days shorter'
    }, {
      icon: '💊',
      text: '46% fewer antibiotic days (daycare kids)'
    }, {
      icon: '🎒',
      text: 'Fewer missed school days'
    }]
  }
}, {
  slug: 'probiotics-food-allergies-kids',
  title: 'Probiotics and Food Allergies: What the Science Says',
  category: 'Immunity',
  readMins: 3,
  date: 'March 29, 2026',
  heroEmoji: '🥜',
  excerpt: 'Food allergies in kids have climbed 50% in 20 years. A balanced gut may help the immune system stay calmer around foods.',
  keyStat: {
    value: '50%',
    label: 'rise in kids’ food allergies over 20 years'
  },
  sections: [{
    h: 'Allergies are on the rise',
    p: 'Over the past 20 years, food allergies in children have gone up by 50%. Scientists are still learning why. One clue keeps showing up: the gut, and the trillions of tiny bacteria that live there.'
  }, {
    h: 'The gut–immune link',
    p: 'Most of a child’s immune system lives in the gut. Research suggests kids with food allergies often have less variety in their gut bacteria and lower levels of helpful microbes. A balanced gut may help the immune system tell friendly foods from real threats.'
  }, {
    h: 'What research suggests',
    p: 'A 2024 review found that early probiotic use — especially in the first year of life — was linked to more balanced immune responses. Some studies suggest certain friendly strains may help support food tolerance. The science is still growing.'
  }, {
    h: 'Timing matters',
    p: 'Studies show the biggest links come from the first 6 to 12 months of life. Earlier tends to help more, though a healthy gut may support kids of any age. Every child is different.'
  }, {
    h: 'One important reminder',
    p: 'Probiotics are not a treatment for food allergies and should never replace allergen avoidance or any medicine your doctor prescribes. Always talk to your child’s allergist before changing their care plan.'
  }],
  takeaways: ['Kids’ food allergies have risen 50% in 20 years.', 'A diverse gut microbiome may help support balanced immune function.', 'L. rhamnosus GG is the best-studied strain here.', 'Probiotics support wellness but never replace medical care or allergist advice.'],
  diagram: {
    type: 'flowchart',
    title: 'How a Balanced Gut Supports the Immune System',
    stat: {
      value: '50%',
      label: 'rise in kids’ food allergies in 20 years'
    },
    steps: [{
      label: 'Diverse gut bacteria',
      sub: 'Bifidobacterium, L. rhamnosus GG'
    }, {
      label: 'Immune system “trained”',
      sub: 'learns friend vs. foe'
    }, {
      label: 'Calmer response to foods',
      sub: 'more balanced'
    }],
    footnote: 'Not a treatment for allergies — always ask your allergist.'
  }
}, {
  slug: 'probiotics-sleep-growth-kids',
  title: 'Sleep Better, Grow Stronger: Probiotics & Development',
  category: 'Gut-Brain',
  readMins: 4,
  date: 'March 29, 2026',
  heroEmoji: '😴',
  excerpt: 'The gut helps make the hormones behind sleep and growth. Supporting gut health may help your child rest deeper and grow well.',
  keyStat: {
    value: '90%',
    label: 'of the body’s serotonin is made in the gut'
  },
  sections: [{
    h: 'The gut–sleep connection',
    p: 'Sleep runs on hormones and brain chemicals, and the gut helps make them. The gut produces far more melatonin (the sleep signal) than the brain, and about 90% of the body’s serotonin is made there too. Since serotonin helps the body make melatonin, gut health and sleep are closely tied.'
  }, {
    h: 'Calming chemicals',
    p: 'Some friendly bacteria are linked to more GABA — the calming brain chemical that helps kids wind down at night. A 2024 review found children with healthier, more diverse gut bacteria reported better sleep quality.'
  }, {
    h: 'Fuel for growing bodies',
    p: 'Growing takes good nutrition, and the gut helps unlock it. Friendly bacteria help break down food and take in nutrients like calcium, iron, and B vitamins. Research suggests kids with balanced gut bacteria tend to have healthier metabolism.'
  }, {
    h: 'Sleep and growth work together',
    p: 'Growth hormone is released mostly during deep sleep. Kids who sleep well tend to grow well. Because a healthy gut may support better sleep, it may support healthy growth too.'
  }, {
    h: 'Simple sleep habits',
    p: 'Pair gut support with good routines: a steady bedtime, screens off an hour before bed, a cool dark room, and skipping sugary snacks late (sugar can throw off gut bacteria).'
  }],
  takeaways: ['The gut helps make melatonin and serotonin, key to sleep.', 'Healthy gut bacteria may support better rest and calm.', 'Good nutrient absorption supports healthy growth.', 'Deep sleep drives growth hormone — so sleep and growth link up.'],
  diagram: {
    type: 'cycle',
    title: 'The Gut–Sleep–Growth Loop',
    center: '90%\nserotonin\nmade in gut',
    nodes: [{
      icon: '🦠',
      label: 'Healthy gut'
    }, {
      icon: '😴',
      label: 'Better sleep'
    }, {
      icon: '📈',
      label: 'Stronger growth'
    }],
    chips: ['Melatonin — sleep signal', 'Serotonin — mood & sleep', 'GABA — calm']
  }
}, {
  slug: 'kids-upset-tummy-probiotics',
  title: 'Always an Upset Tummy? How Probiotics Can Help',
  category: 'Digestion',
  readMins: 3,
  date: 'March 29, 2026',
  heroEmoji: '🤗',
  excerpt: 'Bloating, gas, and stomachaches often trace back to gut balance. Friendly bacteria may help your child’s belly feel better.',
  keyStat: {
    value: '~70%',
    label: 'of the immune system lives in the gut'
  },
  sections: [{
    h: 'Meet the gut’s tiny helpers',
    p: 'Inside every child’s belly live trillions of tiny bacteria — and most of them are good. They help break down food, crowd out bad germs, and keep things running smoothly. When good and bad get out of balance, tummy troubles can start.'
  }, {
    h: 'What are probiotics?',
    p: 'Probiotics are live, friendly bacteria you can eat or drink. You’ll find them in yogurt, kefir, and cheese, or in easy supplements made for kids. Think of them as reinforcements for the gut.'
  }, {
    h: 'What research suggests',
    p: 'Scientists have studied probiotics in kids for years. A large review found they may help support comfortable digestion, more regular bowel movements, and a strong gut lining. Every child is different, so results can vary.'
  }, {
    h: 'Tiny superheroes: SCFAs',
    p: 'A 2024 review noted that probiotics help make short-chain fatty acids (SCFAs). These helpful substances support the gut walls and a calm, balanced gut. Big name, small but mighty job.'
  }, {
    h: 'Easy ways to add them',
    p: 'Add yogurt to breakfast, offer cheese as a snack, blend kefir into a smoothie, or try a daily kids’ probiotic. Small, simple steps can support how your child’s tummy feels.'
  }],
  takeaways: ['About 70% of the immune system lives in the gut.', 'Probiotics may help support comfortable, regular digestion.', 'SCFAs from friendly bacteria help support the gut lining.', 'Look for kids’ probiotics with proven strains and billions of CFU.'],
  diagram: {
    type: 'comparison',
    title: 'Balanced Gut vs. Out-of-Balance Gut',
    highlight: '~70% of the immune system lives in the gut',
    left: {
      label: 'Balanced gut',
      icon: '🤗',
      tone: 'good',
      items: ['Good bacteria win', 'Smooth digestion', 'Less gas & bloating', 'Strong gut lining']
    },
    right: {
      label: 'Out of balance',
      icon: '😣',
      tone: 'bad',
      items: ['Too few good bacteria', 'Bloating', 'Gas', 'Stomachaches']
    }
  }
}, {
  slug: 'fibermaxxing-2026-gut-health',
  title: 'Fibermaxxing: 2026’s Big Gut-Health Trend, Explained',
  category: 'Trends',
  readMins: 3,
  date: 'February 10, 2026',
  heroEmoji: '🌾',
  excerpt: 'Fibermaxxing means eating way more fiber for gut health. Here’s the simple, safe way to think about it for your family.',
  keyStat: {
    value: '15 g',
    label: 'average daily fiber vs. the 25–38 g recommended'
  },
  sections: [{
    h: 'What is fibermaxxing?',
    p: 'Fibermaxxing means adding a lot more fiber to your day — often way past the usual advice. Standard guidance is about 25 to 38 grams a day, but fans of the trend aim for 50 to 75 grams. It grew out of new interest in gut health.'
  }, {
    h: 'Why people love fiber',
    p: 'Fiber feeds the friendly bacteria in the gut, which may support digestion and overall wellness. It also helps you feel full and helps support steady blood sugar. That mix made it a favorite natural-wellness trend.'
  }, {
    h: 'Two kinds of fiber',
    p: 'Soluble fiber dissolves in water and feeds good bacteria — think oats, beans, and chia seeds. Insoluble fiber helps keep things moving — think whole grains, nuts, and veggies with skins. You want both.'
  }, {
    h: 'Most of us get too little',
    p: 'The average American eats only about 15 grams of fiber a day — well below the 25 to 38 grams recommended. So for most families, simply getting to the baseline is a great first goal.'
  }, {
    h: 'Go low and slow',
    p: 'If you add fiber, do it gently. Add just about 5 grams a week, drink plenty of water, and watch how your body feels. Adding too much too fast can upset the stomach.'
  }],
  takeaways: ['Fibermaxxing means eating far more fiber than usual (50–75 g).', 'Most people only get ~15 g a day vs. the 25–38 g recommended.', 'Eat both soluble and insoluble fiber from whole foods.', 'Add fiber slowly (~5 g/week) with plenty of water.'],
  diagram: {
    type: 'stat-row',
    title: 'Fiber by the Numbers',
    tiles: [{
      icon: '🍽️',
      value: '15 g',
      label: 'average daily intake'
    }, {
      icon: '✅',
      value: '25–38 g',
      label: 'recommended range'
    }, {
      icon: '🚀',
      value: '50–75 g',
      label: 'fibermaxxing target'
    }],
    note: 'Low & slow: add about +5 g per week, with plenty of water.'
  }
}];

/* AI-generated lifestyle hero images (hosted) */
(function () {
  var IMG = {
    'skip-the-gummy-probiotics': 'https://d8j0ntlcm91z4.cloudfront.net/user_3B2wnf6jvtcOd8Bm8uHkJf4htKW/hf_20260802_152750_14ea89f0-dc8b-4f92-a2b0-6531b54d5742.png',
    'gut-health-and-your-childs-mood': 'https://d8j0ntlcm91z4.cloudfront.net/user_3B2wnf6jvtcOd8Bm8uHkJf4htKW/hf_20260802_155831_23dc7bd1-2231-4c52-951b-c2699f93658c.png',
    'probiotics-for-kid-constipation': 'https://d8j0ntlcm91z4.cloudfront.net/user_3B2wnf6jvtcOd8Bm8uHkJf4htKW/hf_20260802_155832_6164d434-7d07-4827-9441-b0d8b9484391.png',
    'probiotics-after-antibiotics-kids': 'https://d8j0ntlcm91z4.cloudfront.net/user_3B2wnf6jvtcOd8Bm8uHkJf4htKW/hf_20260802_155834_1d5c7f9f-3dd4-408a-8f06-c6380a3ff774.png',
    'probiotics-tummy-bug-recovery': 'https://d8j0ntlcm91z4.cloudfront.net/user_3B2wnf6jvtcOd8Bm8uHkJf4htKW/hf_20260802_155844_f6f3a047-b4d1-40f0-9243-72e443ae2bba.png',
    'probiotics-itchy-skin-eczema': 'https://d8j0ntlcm91z4.cloudfront.net/user_3B2wnf6jvtcOd8Bm8uHkJf4htKW/hf_20260802_155846_0dc9ce17-54d4-4075-ba89-6386b6b5746a.png',
    'daily-probiotic-fewer-sick-days': 'https://d8j0ntlcm91z4.cloudfront.net/user_3B2wnf6jvtcOd8Bm8uHkJf4htKW/hf_20260802_155847_1a8bce40-c92f-4d2c-898a-20b714befe45.png',
    'probiotics-fewer-colds-school': 'https://d8j0ntlcm91z4.cloudfront.net/user_3B2wnf6jvtcOd8Bm8uHkJf4htKW/hf_20260802_155856_ce363fa6-9dd2-48fa-8448-01e74b40cee8.png',
    'probiotics-food-allergies-kids': 'https://d8j0ntlcm91z4.cloudfront.net/user_3B2wnf6jvtcOd8Bm8uHkJf4htKW/hf_20260802_155858_8da9de6a-e444-4e67-a406-5b2e37a114de.png',
    'probiotics-sleep-growth-kids': 'https://d8j0ntlcm91z4.cloudfront.net/user_3B2wnf6jvtcOd8Bm8uHkJf4htKW/hf_20260802_155859_50f6968e-7818-468b-a8a9-dd04afd45c11.png',
    'kids-upset-tummy-probiotics': 'https://d8j0ntlcm91z4.cloudfront.net/user_3B2wnf6jvtcOd8Bm8uHkJf4htKW/hf_20260802_155916_75fc75ae-1f4d-4cf2-839b-1496bdfc1f34.png',
    'fibermaxxing-2026-gut-health': 'https://d8j0ntlcm91z4.cloudfront.net/user_3B2wnf6jvtcOd8Bm8uHkJf4htKW/hf_20260802_155918_f57fa46d-7c65-429f-acd0-d02daeab8faa.png'
  };
  if (window.BLOG) {
    window.BLOG.forEach(function (p) {
      p.heroImg = IMG[p.slug] || '';
    });
  }
})();